module.exports = __webpack_public_path__ + "static/media/option-1_active.55d54c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/message/option-1_active.png
// module id = 832
// module chunks = 0